
define('text!templates/parts/panel/panel.html',[],function () { return '<div class="panel-header"></div>\n<div class="panel-tabs">\n    <ul class="menu-tabs"></ul>\n</div>\n<div class="panel-content"></div>\n';});

